// extracted by css-extract-rspack-plugin
export default {"container":"ActionBar-module__container__mWhsl","withoutActions":"ActionBar-module__withoutActions__NxMrb"};